<div class="example-container mat-card mat-elevation-z4 p-24">

  <form class="">
    <div class="h2 mb-24">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.ABIERTA.TITULO' | translate}}</div>
    <mat-form-field appearance="outline">
      <mat-label>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.ABIERTA.ACCION' | translate}}</mat-label>
      <textarea matInput required
        (keyup)="enviaTextoPregunta($event)"
        (blur)="guardaPregunta()"
        [(ngModel)]="textoEntrada"
        [disabled]="pasoCompleto"
        name="textoAbierto"
      ></textarea>
      <mat-error>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.ABIERTA.ERROR' | translate}}</mat-error>
    </mat-form-field>
  </form>

</div>
